import { render, staticRenderFns } from "./Gamma.vue?vue&type=template&id=648ba9ec"
import script from "./Gamma.vue?vue&type=script&lang=ts"
export * from "./Gamma.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports